import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import Details from './FileUploadHistory/Details/Details';
import FileUploadHistory from './FileUploadHistory/FileUploadHistory';
import { JSX } from 'react';
import FileUploadConfirm from './FileUploadConfirm';
import ConvertMyTemplateConfirm from './ConvertMyTemplateConfirm/ConvertMyTemplateConfirm';
import { FileConfigurationProvider } from './FileConfigurationProvider';

const Routes = (): JSX.Element => {
  const featureFlags = useModuleFeatureFlag('upload');

  return (
    <FileConfigurationProvider>
      <Switch>
        <ProtectedRoute
          isAllowed={featureFlags.isEnabled && featureFlags.ViewBulkFileUpload}
          showPermission
          path="/file-upload-history"
          exact
          component={FileUploadHistory}
        />
        <ProtectedRoute
          isAllowed={featureFlags.isEnabled && featureFlags.ViewBulkFileUpload}
          showPermission
          path="/file-upload/confirm"
          exact
          component={FileUploadConfirm}
        />
        <ProtectedRoute
          isAllowed={featureFlags.isEnabled && featureFlags.ViewBulkFileUpload}
          showPermission
          path="/file-upload/convert-template/confirm"
          exact
          component={ConvertMyTemplateConfirm}
        />

        <ProtectedRoute
          isAllowed={featureFlags.isEnabled && featureFlags.ViewBulkFileUpload}
          showPermission
          path="/file-upload-history/details/:batchId"
          exact
          component={Details}
        />
      </Switch>
    </FileConfigurationProvider>
  );
};

export default Routes;
